<template>
    <div>
      <div id="container" ref="container">
      </div>
    </div>
</template>
 
<script>
import * as THREE from 'three/build/three.module.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';//点击事件不起作用，切换到three.js-r119
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
import { CSS2DRenderer, CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer.js';
let scene, camera, renderer, controls, labelRenderer, loader, selectObject,
//  thisMouseX, thisMouseY, 
//  lastAutoplay = true,
//  loadedNum = 0,
    currentIndex = 0,
    needObject = [],
    clock = new THREE.Clock(),
    mixer = [],
    models = [];
    
export default {
  name: 'ThreeTest',
  data() {
    return {
      camera: null,
      scene: null,
      renderer: null,
      mesh: null,
      model: null,
      num: 0
    }
  },
  methods: {
    
    /* 场景 */
    initScene: function () {
        scene = new THREE.Scene();
        
    },
    /* 相机 */
    initCamera: function () {//必须先设置一个初始的position

        camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 10000);        
        camera.position.set(-26.270813473242775, 4.1858913257133565, 129.2571030436139);
    },

    /* 渲染器 */
    initRender: function () {
        labelRenderer = new CSS2DRenderer();
        labelRenderer.setSize( window.innerWidth, window.innerHeight );
        labelRenderer.domElement.style.position = 'absolute';
        labelRenderer.domElement.style.top = '0px';
        this.$refs.container.appendChild( labelRenderer.domElement );
        renderer = new THREE.WebGLRenderer({alpha: true,antialias:true});
        renderer.setSize(window.innerWidth, window.innerHeight);
        renderer.outputEncoding = THREE.sRGBEncoding;
        renderer.shadowMap.enabled = true;
        renderer.shadowMap.type = THREE.PCFSoftShadowMap;
        // renderer.domElement.appendChild( labelRenderer.domElement );
        this.$refs.container.appendChild(renderer.domElement);
        const pmremGenerator = new THREE.PMREMGenerator(renderer) // 使用hdr作为背景色
        pmremGenerator.compileEquirectangularShader();
        new RGBELoader()
            .setDataType(THREE.UnsignedByteType)
            .load(`${process.env.BASE_URL}`+'hdr/HDRI_STUDIO_vol2_002.hdr', function (texture) {
                const envMap = pmremGenerator.fromEquirectangular(texture).texture;
                pmremGenerator.dispose();
                // // 这两个可以分开设置
                scene.environment = envMap  // 给场景添加环境光效果
                scene.castShadow = true;
                
            })            
    },

    /* 灯光 */
    initLight: function () {
        var light = new THREE.AmbientLight(0xffffff);
        // light.position.set(0,30,0);
        // light.castShadow = true
        // 
        scene.add(light);

    },
    /* 控制器 */
    initControls: function () {

        controls = new OrbitControls(camera, labelRenderer.domElement);
        controls.target.set(0, -12.003802432153165, 0);
        controls.update();
    },
    /* 调试插件 */
    initGui: function () {
    },
    getAllNodes: function(){

    },
    /* 加载gltf模型 */
    loadGLFT: function(url, index ){
        loader.load(url, (obj) => { 
            //获取模型，并添加到场景
            // loadedNum++;
            // loadedNum === 8 && this.Event.$emit('load', false);
            models[index] = obj.scene;
            console.log('===========models[index]',models[index]);
            index === 0 && scene.add(models[index]);
            setTimeout(()=>{

                this.Event.$emit('load', false);
            }, 500)
            for(let i=0; i<models[index].children.length; i++){
                models[index].children[i].castShadow = true;
                if(models[index].children[i] instanceof THREE.Mesh){
                    
                    needObject.push(models[index].children[i]);
                    window.addEventListener('click', this.onMouseHover, true);
                    window.addEventListener('mousemove', this.onMouseHover, true);

                }
            }
            
            //将模型绑定到动画混合器里面
            mixer[index] = new THREE.AnimationMixer( models[index] );
            //同时将这个外部模型的动画全部绑定到动画混合器里面
            for (let i=0;i<obj.animations.length;i++){

                mixer[index].clipAction(obj.animations[i]).play();
                
            }
            
        })
    },
    createDiv: function(){
        const earthDiv = document.createElement( 'div' );
        earthDiv.className = 'label';
        earthDiv.style.marginTop = '-1em';
        
        const earthLabel = new CSS2DObject( earthDiv );
        earthLabel.position.set( 0, 10, 0 );
        return [earthLabel, earthDiv];
    },
    /* 场景中的内容 */
    initContent: function () {
        // 加载 glTF 格式的模型
        loader = new GLTFLoader();/*实例化加载器*/ 
        this.productInfo.forEach((item, index) => {
            this.loadGLFT(`${process.env.BASE_URL}` + item.modelUrl, index);
        })
    },
    show: function (){

    },

    /* 窗口变动触发 */
    onWindowResize: function () {

        camera.aspect = window.innerWidth / window.innerHeight;
        camera.updateProjectionMatrix();
        renderer.setSize(window.innerWidth, window.innerHeight);
        labelRenderer.setSize( window.innerWidth, window.innerHeight );

    },
    // 鼠标悬浮触发
    onMouseHover: function(event) {
        // thisMouseX = event.clientX;
        // thisMouseY = event.clientY;
        // if(lastAutoplay){
            
        //     this.Event.$emit('autoplay', false);
        //     lastAutoplay = false;
        // }
        // if(loadedNum === 8){
        //     setTimeout(()=>{
                        
        //         if(thisMouseX === event.clientX && thisMouseY === event.clientY){
        //             this.Event.$emit('autoplay', true);
        //             lastAutoplay = true;
                    
        //         }

        //     }, 2000)
        // }
        // 获取 raycaster 和所有模型相交的数组，其中的元素按照距离排序，越近的越靠前
        var intersects = this.getIntersects(event);
        // 获取选中最近的 Mesh 对象
        if (intersects.length != 0 && intersects[0].object instanceof THREE.Mesh) {
            selectObject = intersects[0].object;
            mixer[currentIndex] && mixer[currentIndex]._actions[0] && (mixer[currentIndex].clipAction(mixer[currentIndex]._actions[0]._clip).paused = true);
            this.productInfo.forEach((item, index) => {
                if(index !== currentIndex){
                    return
                }
                let content;
                if(item && item.childInfo){
                    content = Object.prototype.hasOwnProperty.call(item.childInfo, selectObject.name);
                }
                
                if(content){
                    
                    document.getElementById('introduce').style.top=event.clientY - document.getElementById('content1').offsetHeight +'px';
                    document.getElementById('introduce').style.left=event.clientX+'px';
                    
                }
            })
        } else {
            mixer[currentIndex] && mixer[currentIndex]._actions[0] && (mixer[currentIndex].clipAction(mixer[currentIndex]._actions[0]._clip).paused = false);

        }
    },
    // 获取与射线相交的对象数组
    getIntersects: function (event) {
        event.preventDefault();
        // 声明 raycaster 和 mouse 变量
        var raycaster = new THREE.Raycaster();
        var mouse = new THREE.Vector2();
 
        // 通过鼠标点击位置,计算出 raycaster 所需点的位置,以屏幕为中心点,范围 -1 到 1
        mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
        //通过鼠标点击的位置(二维坐标)和当前相机的矩阵计算出射线位置
        raycaster.setFromCamera(mouse, camera);
        // 获取与射线相交的对象数组，其中的元素按照距离排序，越近的越靠前
        var intersects = raycaster.intersectObjects(needObject);
        //返回选中的对象
        return intersects;
    },

    /* 数据更新 */
    update: function () {
       
    },

    /* 初始化 */
    init: function () {

        this.initScene();
        this.initCamera();
        this.initRender();
        // this.initLight();
        this.initControls();
        // this.initContent();
        /* 监听事件 */
        window.addEventListener('resize', this.onWindowResize, false);
    },
    /* 循环渲染 */
    animate: function () {
        window.camera = camera;
        window.controls = controls;
        requestAnimationFrame(this.animate);
        var time = clock.getDelta();
        if (mixer && mixer.length > 0) {
            mixer.forEach(item=>{
                item.update(time);

            })    
        }
        
        labelRenderer.render( scene, camera );
        renderer.render(scene, camera);
        this.update();

    }
  },
  created(){
    console.log('============created');
    
  },
  mounted(){
      console.log('============mounted');
      this.init();
      this.animate();
      this.Event.$on('carouselChange', (newIndex, oldIndex) => {
         if(models && models[newIndex]){
            scene.add(models[newIndex]);
            currentIndex = newIndex;
            camera.position.set(-26.270813473242775, 4.1858913257133565, 129.2571030436139);
            controls.target.set(0, -12.003802432153165, 0);
            controls.update();
            mixer[newIndex].clipAction(mixer[newIndex]._actions[0]._clip).reset();
         }
         if(models && models[oldIndex]){
            scene.remove(models[oldIndex]);
         }
      });
  },
  activated(){
      console.log('============activated');
    
    
  },
  deactivated(){
    console.log('============deactivated');
    let obj = scene.children[0];
    scene.remove(obj);
  },
  watch:{
    productInfo(value){
        console.log('============watchproductInfo', value);
        this.initContent();
        
    }
  },
  props: {
    productInfo: Array
  }

}
</script>
<style>
  
  
</style>
